import gql from 'graphql-tag';

export const GET_CANCEL_POLICY = gql`

query(
    $golf_group_code: String
    $golf_code: String
    ){
    GetCancelPolicyList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        ){
        CancelPolicyList{
            cancel_code
            cancel_code_name
            cancel_detail
        }
    }
}
`;

export const GET_ALL_CANCEL_POLICY_LIST = gql`
query(
    $golf_group_code: String
    $golf_code: String
    $limit_rows: Int
    $begin_row: Int
){
    GetCancelPolicyListByPlanMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        limit_rows: $limit_rows
        begin_row: $begin_row
    ){
        CancelPolicyMasterList{
            golf_code
            golf_group_code
            cancel_code
            cancel_code_name
            cancel_detail
            valid_flag
        }
    count
    }
}
`;

export const REGISTER_CANCEL_POLICY_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $cancel_code_name: String
    $cancel_detail: String
    $valid_flag: Int
  ){
    RegisterCancelPolicyMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        cancel_code_name: $cancel_code_name
        cancel_detail: $cancel_detail
        valid_flag: $valid_flag
  ){
    result
  }
}
`;

export const UPDATE_CANCEL_POLICY_MASTER = gql`
  mutation(
    $golf_group_code: String
    $golf_code: String
    $cancel_code_name: String
    $cancel_code: String
    $cancel_detail: String
    $valid_flag: Int
  ){
    UpdateCancelPolicyMaster(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        cancel_code_name: $cancel_code_name
        cancel_code: $cancel_code
        cancel_detail: $cancel_detail
        valid_flag: $valid_flag
  ){
    result
  }
}
`;
